// extracted by mini-css-extract-plugin
export default {"variables":"\"variables.css\"","first-table-shrink-width":"1050px","container":"DamagedLostBySupplierPalletsSummarySection_container__zz2AO"};